import {Activity, Calendar, ChevronLeft, ChevronRight, RefreshCw} from "lucide-react";
import React from "react";
import { Select } from "./Select";
import { COUNTRIES } from "../constants/countries";
import DesktopGameCard from "./DesktopGameCard";

const GamesView = ({
  games,
  filters,
  onFilterChange,
  leagues,
  loading,
  selectedGame,
  onGameSelect,
  pagination,
  onPageChange,
  t
}) => (
  <div className="space-y-6">
    {/* Filters */}
    <div className="border border-white/10 rounded-sm p-6 bg-white/[0.03]">
      {/* Games Grid */}
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <h2 className="text-2xl font-black uppercase tracking-tight text-white flex items-center gap-3">
            {t('Games')} ({games.length})
          </h2>
          {pagination && pagination.totalPages > 1 && (
            <div className="text-[11px] font-mono uppercase tracking-[0.3em] text-gray-500">
              {t('Page')} {pagination.currentPage} {t('of')} {pagination.totalPages}
            </div>
          )}
        </div>

        {loading ? (
          <div className="border border-white/10 rounded-sm p-12 text-center bg-black">
            <RefreshCw className="animate-spin mx-auto mb-4 text-white" size={32} />
            <p className="text-xs font-mono uppercase tracking-[0.3em] text-gray-400">
              {t('Loading games...')}
            </p>
          </div>
        ) : games.length === 0 ? (
          <div className="border border-white/10 rounded-sm p-12 text-center bg-black">
            <Calendar className="mx-auto mb-4 text-gray-600" size={36} />
            <p className="text-xs font-mono uppercase tracking-[0.3em] text-gray-400">
              {t('No games found')}
            </p>
            <p className="text-[11px] font-mono uppercase tracking-widest text-gray-600 mt-2">
              {t('Try selecting a different date or league')}
            </p>
          </div>
        ) : (
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {games.slice(
              pagination ? (pagination.currentPage - 1) * pagination.perPage : 0,
              pagination ? pagination.currentPage * pagination.perPage : games.length
              ).map((game, index) => (
                <DesktopGameCard
                  key={game.id || `${game.league?.id}-${index}`}
                  game={game}
                  isSelected={selectedGame?.id === game.id}
                  onGameSelect={onGameSelect}
                />
              ))}
          </div>
        )}

        {/* Pagination Controls */}
        {!loading && games.length > 0 && pagination && pagination.totalPages > 1 && (
          <div className="mt-6 flex justify-center">
            <div className="flex items-center gap-3">
              <button
                onClick={() => onPageChange(pagination.currentPage - 1)}
                disabled={pagination.currentPage === 1}
                className="px-3 py-2 border border-white/10 text-white text-xs font-mono uppercase tracking-widest rounded-sm bg-transparent hover:border-white/30 disabled:opacity-40 transition-all"
                aria-label={t('Previous page')}
              >
                <ChevronLeft size={16} />
              </button>

              <span className="px-4 py-2 text-xs font-mono uppercase tracking-[0.3em] text-gray-400">
                {pagination.currentPage} / {pagination.totalPages}
              </span>

              <button
                onClick={() => onPageChange(pagination.currentPage + 1)}
                disabled={pagination.currentPage === pagination.totalPages}
                className="px-3 py-2 border border-white/10 text-white text-xs font-mono uppercase tracking-widest rounded-sm bg-transparent hover:border-white/30 disabled:opacity-40 transition-all"
                aria-label={t('Next page')}
              >
                <ChevronRight size={16} />
              </button>
            </div>
          </div>
        )}
      </div>
    </div>


  </div>
);

export default GamesView;
